export default __webpack_public_path__ + "static/media/searchBLog.f16f5047.svg";